<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="40%"
    class="shareClueDialog"
    @close="dialogCloseHandle"
  >
    <el-form class="common_form" label-position="left" ref="shareClueForm" :rules="rules" label-width="130px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item :label="label" prop="userId">
            <el-select
              v-model="formData.userId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="userLoading"
            >
              <el-option v-for="(item, index) in userList" :key="index" :label="item.userName" :value="item.userId" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { cluePoolListApi } from '../../service';
export default {
  data () {
    return {
      rules: {
        userId: [
          { required: true, message: '请选择负责人', trigger: 'change' }
        ]
      },
      dialogVisible: false,
      formData: {},
      userList: [],
      userLoading: false
    };
  },
  props: {
    title: {
      type: String,
      default: '分配线索'
    },
    label: {
      type: String,
      default: '负责人'
    },
    shareClueShow: {
      type: Boolean,
      default: false
    },
    selectedPoolList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    shareClueShow (val) {
      if (val) {
        // this.getDeptStaffList();
        this.remoteMethod('');
      } else {
        this.formData = {};
      }
      this.$nextTick(() => {
        this.$refs.shareClueForm.clearValidate();
      });
      this.dialogVisible = val;
    }
  },
  methods: {
    remoteMethod (query) {
      this.userLoading = true;
      cluePoolListApi.getDeptStaffList(this.selectedPoolList[0].leadId, query).then(res => {
        if (res.status === '200') {
          if (res.data && res.data.length > 0) {
            this.userList = res.data;
          } else {
            this.userList = [];
          }
        }
        this.userLoading = false;
      });
    },
    submitHandlen () {
      this.$refs['shareClueForm'].validate((valid) => {
        if (valid) {
          let params = {
            userId: this.formData.userId
          };
          params.leadIdList = this.selectedPoolList.map((item) => {
            return item.leadId;
          });
          this.$emit('submitHandle', params);
        }
      });
    },
    getDeptStaffList () {
      cluePoolListApi.getDeptStaffList(this.selectedPoolList[0].leadId).then(res => {
        if (res.status === '200') {
          this.userList = res.data;
        }
      });
    },
    dialogCloseHandle () {
      this.$emit('dialogCloseHandle');
    }
  }
};
</script>

<style lang="scss" scoped>
  .shareClueDialog{
    ::v-deep.el-dialog{
      margin-top: 20vh!important;
      .el-dialog__body{
        min-height: 150px;
      }
    }
  }
</style>
